import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchUpdateSettings, createUpdateSetting, deleteUpdateSetting, updateUpdateSetting } from '../../common/jsonstore';
import { UpdateSetting } from '../../common/model';
import { AppState } from '../../redux/store/rootReducer';
import { AppDispatch } from '../../redux/store/store';
import { isTokenExpired } from '../../services/authenticationService';
import { signOut } from '../../services/localStorage';
import { handleError, handleSuccess } from '../../services/messageApiService';


const initialState: UpdateSetting[] = []; //model interface

const UpdateSettingSlice = createSlice({
  name: 'UpdateSettings',
  initialState,
  reducers: {
    receiveUpdateSettings(state, action: PayloadAction<UpdateSetting[]>) {
      return action.payload;
    },
    receiveUpdateSetting(state, action: PayloadAction<UpdateSetting>) {
      state.push(action.payload);
    },
  }
});

// export const { toggleUpdateSetting } = UpdateSettingSlice.actions;

export const loadUpdateSettings = (): any => async (dispatch: AppDispatch) => {
  if (isTokenExpired()) {
    const UpdateSettings = await fetchUpdateSettings().then((res: any) => {
      dispatch(UpdateSettingSlice.actions.receiveUpdateSettings(res));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Update settings not loaded';
        handleError(msg);
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const addUpdateSetting = (newUpdateSetting: UpdateSetting): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const respp = await createUpdateSetting(newUpdateSetting).then((res: any) => {
      dispatch(UpdateSettingSlice.actions.receiveUpdateSetting(res));
      handleSuccess('Settings added successfully');
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Settings not added';
        handleError(msg);
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const modifyUpdateSetting = (newUpdateSetting: UpdateSetting, id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const respp = await updateUpdateSetting(newUpdateSetting, id).then((res: any) => {
      const updatedUpdateSettings = getState().UpdateSettings.map(el => (el.id === id ? res : el))
      dispatch(UpdateSettingSlice.actions.receiveUpdateSettings(updatedUpdateSettings));
      handleSuccess('Settings updated successfully');
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Settings not updated';
        handleError(msg);
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const removeUpdateSetting = (id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    deleteUpdateSetting(id).then((res: any) => {
      const updatedUpdateSettings = getState().UpdateSettings.filter((item) => item.id !== id);
      dispatch(UpdateSettingSlice.actions.receiveUpdateSettings(updatedUpdateSettings));
      handleSuccess('Settings deleted successfully');
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Settings not deleted';
        handleError(msg);
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export default UpdateSettingSlice.reducer;
